export enum ViewContextEnum {
  BACKOFFICE = "BACKOFFICE",
  CUSTOMER = "CUSTOMER"
}
